import identity from './identity.js';

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

export default castFunction;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_castFunction.js
// module id = 57
// module chunks = 0